export const SOCIAL_LINKS = {
  instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://www.instagram.com',
  tiktok: process.env.REACT_APP_SOCIAL_TIKTOK || 'https://www.tiktok.com',
  facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://www.facebook.com',
  x: process.env.REACT_APP_SOCIAL_X || 'https://x.com',
  discord: process.env.REACT_APP_SOCIAL_DISCORD || 'https://discord.com',
};
